import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const listarTiposParametros = () => {
    return axios.get(`${API_URL}/administrar/tiposParametros`, {
        headers: getHeaders(),
    });
};

export const crearOEditarTipoParametro = async (tipoParametro) => {
    try {
        if (tipoParametro.id) {
            const resp = await axios.put(
                `${API_URL}/administrar/tiposParametros/${tipoParametro.id}`,
                tipoParametro,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/tiposParametros`,
            tipoParametro,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTiposParametros = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/administrar/tiposParametros/select`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarTipoParametro = async (id_tipo_parametro) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/tiposParametros/${id_tipo_parametro}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarTipoParametro = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/tiposParametros/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
